// The phone's dark-bar icon button (the hamburger, and the drawer's close that
// replaces it), in a module of its own so MobileNavBar and SidebarHeader share
// one string without an import cycle (MobileNavBar renders the Sidebar).

/**
 * Chrome-less on the dark bar, a 44px touch target with a wash on hover and press.
 * Why it carries no fill or border: see `MobileNavBar`'s hamburger.
 */
export const DARK_BAR_ICON_BUTTON =
    'min-h-11 min-w-11 border-transparent bg-transparent hover:bg-white/10 enabled:active:bg-white/20';

/**
 * BL-2553: the leading icon button's pull-in. `-ml-2.5` takes the 44px target's
 * 10px inset back out, so the 24px glyph's left edge sits on the 16px gutter and
 * the lockup after it lands at the same x in the bar and in the drawer.
 */
export const DARK_BAR_LEADING_PULL = '-ml-2.5';
